<template>
  <div class="list-group">
    <button type="button" v-for="(placeholder, index) in filteredPlaceholders" :key="index" class="list-group-item list-group-item-action" :class="{ active: selectedIndex === index }" @click="command({ key: filteredPlaceholders[index].key })">
      <PlaceholderVNode :node="slot({ placeholder, preview: false })"/>
    </button>
  </div>
</template>

<script setup>
import {computed, ref, watch} from "vue";
import PlaceholderVNode from "./PlaceholderVNode";

const props = defineProps({
  placeholders: Array,
  command: {
    type: Function,
    required: true
  },
  slot: Function,
  editor: Object
});

const selectedIndex = ref(0);

watch(() => props.placeholders, () => {
  selectedIndex.value = 0
});

const query = computed(() => {
  const node = props.editor.state.doc.nodeAt(props.editor.state.selection.head - 1);
  let startIndex = props.editor.state.selection.head - 1;
  while (startIndex >= 0) {
    if (props.editor.state.doc.nodeAt(startIndex) !== node) {
      break;
    }
    startIndex--;
  }
  const relativeHead = props.editor.state.selection.head - 1 - startIndex;

  let beforeIndex = relativeHead;
  while (beforeIndex >= 0) {
    if (node.textBetween(beforeIndex, beforeIndex + 1) === "@") {
      break;
    }
    beforeIndex--;
  }

  const length = node.text.length;
  let afterIndex = relativeHead;
  while (afterIndex < length) {
    if (node.textBetween(afterIndex, afterIndex + 1) === " ") {
      break;
    }
    afterIndex++;
  }
  return node.textBetween(beforeIndex + 1, afterIndex).trim();
});

const filteredPlaceholders = computed(() => {
  return query.value && query.value.length > 0 ? props.placeholders.filter(item => JSON.stringify(item).toLowerCase().includes(query.value)) : props.placeholders;
});

function onKeyDown({ event }) {
  if (event.key === 'ArrowUp') {
    selectedIndex.value = selectedIndex.value === 0 ? filteredPlaceholders.value.length - 1 : selectedIndex.value - 1;
    return true
  }
  if (event.key === 'ArrowDown') {
    selectedIndex.value = selectedIndex.value >= filteredPlaceholders.value.length - 1 ? 0 : selectedIndex.value + 1;
    return true
  }
  if (event.key === 'Enter') {
    props.command({ key: filteredPlaceholders.value[selectedIndex.value].key });
    return true
  }
  return false;
}

defineExpose({
  onKeyDown
});

</script>